import { Message, MetaParams, State } from "./types"
import moment from 'moment'

const getInitialState = (): State => ({
    data: [],
    stop: false,
    metaParams: {legends: [], parameters: []}
})

export const reducer: WidgetReducerType<State, Message> = (state = getInitialState(), message, ) => {    
    if (!message) {        
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    switch (message.type) {        
        case 'start':
            const init = getInitialState(); 
            return {...init, metaParams: message.events.info}
        case 'event':     
            const data = message.events[0]?.list || []            
            return {...state, data}  
      case 'stop': 
            return {...state, stop:true}

        default:
            return state
    }
}